import React from "react";
import Loading from "../../Loder";
const ReferralModal = React.lazy(() => import("./ReferralModal"));

const ReferFriend = () => {
  return (
    <div>
      <React.Suspense fallback={<Loading />}>
        <ReferralModal from="User" />
      </React.Suspense>
    </div>
  );
};

export default ReferFriend;
